"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _link = require("@react-aria/link");
var _react = _interopRequireDefault(require("react"));
var _reactAria = require("react-aria");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
function getColor(disabled, parentDisabled, theme) {
  if (disabled) {
    return parentDisabled ? theme.sys.color.text.disabled.ondisabled : theme.sys.color.text.disabled.onlight;
  } else {
    return theme.comp.textlink.color.text.default;
  }
}
var StyledLink = _styledComponents.default.a.withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-161ufj-0"
})(["cursor:pointer;color:", ";", " ", " &:hover{color:", ";background-color:", ";}&:focus,&:active{outline:0;outline-style:none;-moz-outline-style:none;}&.focus-ring{border-radius:", ";outline:1px solid ", ";}&:active{color:", ";background-color:", ";}&[disabled]{pointer-events:none;cursor:default;}"], function (_ref) {
  var $disabled = _ref.$disabled,
    $parentDisabled = _ref.$parentDisabled,
    theme = _ref.theme;
  return getColor($disabled, $parentDisabled, theme);
}, function (_ref2) {
  var $fontSize = _ref2.$fontSize,
    theme = _ref2.theme;
  return theme.sys.font.link[$fontSize];
}, function (_ref3) {
  var $ellipsis = _ref3.$ellipsis;
  return $ellipsis ? (0, _styledComponents.css)(["width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]) : (0, _styledComponents.css)(["width:fit-content;"]);
}, function (_ref4) {
  var $disabled = _ref4.$disabled,
    theme = _ref4.theme;
  return $disabled ? theme.sys.color.text.disabled.onlight : theme.comp.textlink.color.text.hover;
}, function (_ref5) {
  var $disabled = _ref5.$disabled,
    theme = _ref5.theme;
  return $disabled ? 'transparent' : theme.comp.textlink.color.background.hover;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.sys.size.borderradius.focusring;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.sys.color.border.focusring;
}, function (_ref8) {
  var $disabled = _ref8.$disabled,
    theme = _ref8.theme;
  return $disabled ? theme.sys.color.text.disabled.onlight : theme.comp.textlink.color.text.pressed;
}, function (_ref9) {
  var $disabled = _ref9.$disabled,
    theme = _ref9.theme;
  return $disabled ? 'transparent' : theme.comp.textlink.color.background.pressed;
});
var Link = /*#__PURE__*/_react.default.forwardRef(function (_ref10, ref) {
  var _ref10$href = _ref10.href,
    href = _ref10$href === void 0 ? 'javascript:void(0);' : _ref10$href,
    _ref10$target = _ref10.target,
    target = _ref10$target === void 0 ? '_self' : _ref10$target,
    children = _ref10.children,
    _ref10$size = _ref10.size,
    size = _ref10$size === void 0 ? '1' : _ref10$size,
    _ref10$disabled = _ref10.disabled,
    disabled = _ref10$disabled === void 0 ? false : _ref10$disabled,
    _ref10$ellipsis = _ref10.ellipsis,
    ellipsis = _ref10$ellipsis === void 0 ? false : _ref10$ellipsis,
    _ref10$parentDisabled = _ref10.parentDisabled,
    parentDisabled = _ref10$parentDisabled === void 0 ? false : _ref10$parentDisabled,
    props = _objectWithoutProperties(_ref10, ["href", "target", "children", "size", "disabled", "ellipsis", "parentDisabled"]);
  var _ref11 = (0, _link.useLink)(props, ref),
    linkProps = _ref11.linkProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactAria.FocusRing, {
    focusRingClass: 'focus-ring',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, _objectSpread({}, linkProps, {
      ref: ref,
      href: href,
      target: target,
      $fontSize: size,
      $disabled: disabled,
      $parentDisabled: parentDisabled,
      $ellipsis: ellipsis
    }, props, {
      children: children
    }))
  });
});
var _default = exports.default = Link;